module.exports = __webpack_public_path__ + "img/gyf.552e63c9.jpg";